import React, { useEffect, useState } from "react";
import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
  stringifyData,
} from "../../Pages/utils/page";
import axios from "axios";
import moment from "moment";
import ProductCountdown from "../Countdown/Countdown";
import ReferralAddressModal from "./ReferralAddressModal";
import { toast } from "react-toastify";
import ReferralAddressChargesModal from "./ReferralAddressChargesModal";
const Rewards = ({ getProfileData, topUsersData, GetTopUsers }) => {
  const FetchToken = GetLocalStorageParsed("AuthToken");
  const [rewardList, setRewardList] = useState([]);
  const [claimedRewardList, setClaimedRewardList] = useState([]);
  const [show, setShow] = useState();

  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [combinePromoData, setCombinePromoData] = useState();
  const [applyButton, setApplyButton] = useState(false);

  const [deliveryCharge, setDeliveryCharge] = useState();
  const [promoData, setPromoData] = useState();

  const [promoDataEmail, setPromoDataEmail] = useState();
  const [promoClickData, setPormoClickData] = useState();
  const [totalValue, setTotalValue] = useState();
  const [finalValue, setFinalValue] = useState();
  const [showAddressModal, setShowAddressModal] = useState();
  const [selectedAddress, setSelectedAddress] = useState();

  // get Promo
  const getPromo = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/PromoCode/GetPromoCodesLimitedUsers`,
    };
    axios(option)
      .then((e) => {
        setPromoData(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };
  // get Promo
  // const getDeliveryCharge = () => {
  //   const option = {
  //     method: "GET",
  //     headers: {
  //       accept: "*/*",
  //       Authorization: `Bearer ${loginToken || " "}`,
  //     },
  //     url: `${Apiurl()}/api/SuperAdmin/GetDefaultSetting`,
  //   };
  //   axios(option)
  //     .then((e) => {
  //       const data = parseData(e?.data?.result);
  //       setDeliveryCharge(parseData(e?.data?.result));
  //       setTotalValue(data?.[0]?.DeliveryCharges);
  //       setFinalValue(data?.[0]?.DeliveryCharges);
  //     })
  //     .catch((error) => {});
  // };

  const getPromoCodeByEmail = (item) => {
    const data = {
      email: getProfileData?.Email,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': `Bearer ${loginToken || " "}`
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/PromoCode/GetPromoCodesByEmail`,
    };
    axios(option)
      .then((e) => {
        setPromoDataEmail(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };

  useEffect(() => {
    getPromo();
    // getDeliveryCharge();
  }, []);
  useEffect(() => {
    if (getProfileData) {
      getPromoCodeByEmail();
    }
  }, [getProfileData]);
  useEffect(() => {
    const combine = [...(promoData || []), ...(promoDataEmail || [])];
    setCombinePromoData(combine);
  }, [promoDataEmail, promoData]);

  const GetRewardList = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken ? loginToken : ""}`,
      },
      url: `${Apiurl()}/api/Customer/GetAvailableRewards`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        const dataformat = data?.map((item) => ({
          ...item,
          selectedQuantity: 0,
        }));
        setRewardList(dataformat);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    GetRewardList();
  }, []);
  const GetClaimedRewardList = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken ? loginToken : ""}`,
      },
      url: `${Apiurl()}/api/Customer/GetClaimedRewards`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setClaimedRewardList(data);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    GetClaimedRewardList();
  }, []);
  const handleClaimReward = (item) => {
    setTotalValue(item?.DeliveryCharges);

    if (item?.selectedQuantity < 1) {
      toast.error("Quantity can not be less than 1");
      return;
    }
    setShow(item);
  };
  const handleChangeSelectedQuantity = (e, item) => {
    const { value } = e.target;
    if (/^\d*$/.test(value)) {
      const updatedList = rewardList?.map((i) => {
        if (item?.id === i?.id) {
          return { ...i, selectedQuantity: value === "" ? 0 : Number(value) };
        }
        return i;
      });
      setRewardList(updatedList);
    }
  };

  const handleIncreaseSelectedQuantity = (item) => {
    if (item?.selectedQuantity === item?.Quantity) {
      return;
    } else {
      const updatedList = rewardList?.map((i) => {
        if (item?.Id === i?.Id) {
          return { ...i, selectedQuantity: item?.selectedQuantity + 1 };
        }
        return i;
      });
      setRewardList(updatedList);
    }
  };

  const handleDecreaseSelectedQuantity = (item) => {
    if (item?.selectedQuantity > 1) {
      const updatedList = rewardList?.map((i) => {
        if (item?.Id === i?.Id) {
          return { ...i, selectedQuantity: item?.selectedQuantity - 1 };
        }
        return i;
      });
      setRewardList(updatedList);
    }
  };
  const [appliedPromoId, setAppliedPromoId] = useState(null);

  const handleApplyPromo = (item) => {
    setAppliedPromoId(item.Id);

    setPormoClickData(item);

    setApplyButton(true);
    const adjustedFinalValue = Math.max(
      0,
      show?.DeliveryCharges - (item?.MinAmount || 0)
    ); // Ensures result is at least 0
    setFinalValue(adjustedFinalValue);
    const data = {
      Id: item?.Id,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': `Bearer ${loginToken || " "}`
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/PromoCode/GetPromoCodeById`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
      })
      .catch((error) => {});
  };
  const handleRemovePromo = () => {
    setAppliedPromoId(null);

    setApplyButton(false);
    setFinalValue(show?.DeliveryCharges);
    setTotalValue(show?.DeliveryCharges);
  };
  const handlePay = async (item) => {
    // return
    const options = {
      key: "rzp_live_SEIuC9F9Y9pG1r", //live
      // key: "rzp_test_0F6zCrTs97XdnP", //test
      amount: stringifyData(finalValue * 100),
      currency: "INR",
      name: "Shop Saverz",
      description: "Payment for Order or money for wallet",
      // order_id: orderId,
      prefill: {
        name: getProfileData?.Name,
        email: getProfileData?.Email,
        contact: getProfileData?.PhoneNumber,
      },
      handler: async (response) => {
        const data = {
          Id: "00000000-0000-0000-0000-000000000000",
          RewardId: showAddressModal?.Id,
          UserId: null,
          FromDate: null,
          EndDate: null,
          Quantity: showAddressModal?.selectedQuantity  ,
          Status: null,
          IsMail: null,
          ShippingAddressId: null,
          TotalReferralPoints: 0,
          ClaimedQuantity: null,
          ClaimedDate: null,

          ReferralReward: null,
          User: null,
          DispatchStatus: null,
          RemainingQuantity: null,
          Description: null,
          ReferralPointPerQuantity: null,
          DeliveryCharges: null,
          IsClaimed: null,
          IsPromoApplied: null,
          TotalAmountInformation: null,
          PromoCodeId: promoClickData?.Id,
          PromocodeDiscount: null,
          PayableAmount: totalValue,
          TransactionId: response?.razorpay_payment_id,
          RevertQuantity: 0,
          RevertingQuantity: null,
        };

        const option = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${loginToken}`,
          },
          data: stringifyData(data),
          url: `${Apiurl()}/api/Customer/ClaimReward`,
        };
        axios(option)
          .then((e) => {
            if (e?.data?.status === "OK") { 
              toast.success(e?.data?.message);
              GetClaimedRewardList();
              GetTopUsers();
              setShowAddressModal();
            }
            if (e?.data?.status === "BadRequest") {
              toast.error(e?.data?.message);
            }
          })
          .catch((error) => {});
      },
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

  const handlePayment = () => {
    if (finalValue <= 0) {
      const data = {
        Id: "00000000-0000-0000-0000-000000000000",
        RewardId: showAddressModal?.Id,
        UserId: null,
        FromDate: null,
        EndDate: null,
        Quantity: showAddressModal?.selectedQuantity,
        Status: "In Progress",
        IsMail: null,
        ShippingAddressId: selectedAddress?.Id,
        TotalReferralPoints: 0,
        ClaimedQuantity: null,
        ClaimedDate: new Date(),

        ReferralReward: null,
        User: null,
        DispatchStatus: null,
        RemainingQuantity: null,
        Description: null,
        ReferralPointPerQuantity: null,
        DeliveryCharges: null,
        IsClaimed: null,
        IsPromoApplied: null,
        TotalAmountInformation: null,
        PromoCodeId: promoClickData?.Id,
        PromocodeDiscount: null,
        PayableAmount: null,
        TransactionId: null,
        RevertQuantity: 0,
        RevertingQuantity: null,
      };

      const option = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${loginToken}`,
        },
        data: stringifyData(data),
        url: `${Apiurl()}/api/Customer/ClaimReward`,
      };
      axios(option)
        .then((e) => {
          if (e?.data?.status === "OK") {
            toast.success(e?.data?.message);

            setShowAddressModal();
            GetRewardList();
            GetClaimedRewardList();
          }
          if (e?.data?.status === "BadRequest") {
            toast.error(e?.data?.message);
          }
        })
        .catch((error) => {});
    } else {
      handlePay();
    }
  };

  return (
    <div className="container">
      <div className="referrals_tabs_data">
        <div className="row">
          <div className="col-lg-12 mb_commn_pd_0"></div>
        </div>

        <div className="row">
          <div className="col-lg-12 mb_commn_pd_0"></div>
        </div>
        <div className="row">
          <div className="col-lg-12 mb_commn_pd_0">
            <h4 className="common_heading">Available Rewards</h4>
            {rewardList?.length ? (
              <div className="table-responsive custom-table-01">
                <table className="table table-striped mb-0">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Reward Image</th>
                      <th>Reward Name</th>
                      <th>End Date</th>
                      <th>Total Referral</th>
                      <th>Total Quantity</th>
                      <th>Remaining Quantity</th>
                      <th>Description</th>
                      <th>Time Left</th>
                      <th>Select Quantity</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rewardList?.map((item, index) => (
                      <tr
                        className={
                          item?.RemainingQuantity == 0 ? "frozen-row" : ""
                        }
                      >
                        <td>{index + 1}</td>
                        <td>
                          <a>
                            <img
                              src={`${Apiurl()}/${
                                item?.RewardImage?.split('"')?.[1]
                              }`}
                              alt="No Image"
                              style={{ maxHeight: "50px", maxWidth: "50px" }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "/Images/no-product-img-700.jpg";
                              }}
                            />
                          </a>
                        </td>
                        <td>{item?.RewardName}</td>
                        <td>{moment(item?.EndDate).format("DD-MM-YYYY")}</td>
                        <td>{item?.ReferralPoint}</td>
                        <td>{item?.Quantity}</td>
                        <td>{item?.RemainingQuantity}</td>
                        <td>{item?.Description}</td>
                        <td className="reff_center_tb_wdt time-left">
                          <ProductCountdown item={item} val="referral" />
                        </td>
                        <td>
                          <div className="quantity">
                            <button
                              className="minus"
                              onClick={() =>
                                handleDecreaseSelectedQuantity(item)
                              }
                            >
                              −
                            </button>
                            <input
                              className="input-box"
                              value={item?.selectedQuantity}
                              onChange={(e) =>
                                handleChangeSelectedQuantity(e, item)
                              }
                            />
                            <button
                              className="plus"
                              onClick={() =>
                                handleIncreaseSelectedQuantity(item)
                              }
                            >
                              +
                            </button>
                          </div>
                        </td>
                        <td>
                          <button
                            type="button"
                            className="common_btn relaunch-btn"
                            onClick={() => handleClaimReward(item)}
                          >
                            Claim
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p>No Reward Program Available</p>
            )}
          </div>
        </div>
        <div className="claimed_history_section">
          <div className="row">
            <div className="col-lg-12 mb_commn_pd_0">
              <h4 className="common_heading">Claimed Rewards</h4>
              <div className="col-lg-12 col-sm-12">
                {claimedRewardList?.length ? (
                  <div className="table-responsive custom-table-01">
                    <table className="table table-striped mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Reward Image</th>
                          <th>Reward Name</th>
                          <th>Claimed Date</th>
                          <th>Claimed Quantity</th>
                          <th>Referral Per Quantity</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {claimedRewardList?.map((item, index) => (
                          <tr>
                            <td>{index + 1}</td>
                            <td>
                              <a>
                                <img
                                  src={`${Apiurl()}/${
                                    item?.ReferralReward?.RewardImage?.split(
                                      '"'
                                    )?.[1]
                                  }`}
                                  alt="No Image"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      "/Images/no-product-img-700.jpg";
                                  }}
                                  style={{
                                    maxHeight: "50px",
                                    maxWidth: "50px",
                                  }}
                                />
                              </a>
                            </td>
                            <td>{item?.ReferralReward?.RewardName}</td>
                            <td>
                              {moment(item?.ClaimedDate).format("DD-MM-YYYY")}
                            </td>
                            <td>{item?.ClaimedQuantity}</td>
                            <td>{item?.ReferralPointPerQuantity}</td>
                            <td>{item?.Status}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="data_not-availble_box">
                    <p className="mb-1">No Claimed History Available !!!</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ReferralAddressModal
        showAddressModal={showAddressModal}
        setShowAddressModal={setShowAddressModal}
        handlePayment={handlePayment}
        setSelectedAddress={setSelectedAddress}
        selectedAddress={selectedAddress}
      />
      <ReferralAddressChargesModal
        show={show}
        setShow={setShow}
        combinePromoData={combinePromoData}
        applyButton={applyButton}
        handleRemovePromo={handleRemovePromo}
        handleApplyPromo={handleApplyPromo}
        deliveryCharge={deliveryCharge}
        finalValue={finalValue}
        totalValue={totalValue}
        promoClickData={promoClickData}
        appliedPromoId={appliedPromoId}
        setShowAddressModal={setShowAddressModal}
        topUsersData={topUsersData}
      />
    </div>
  );
};

export default Rewards;
